import React from 'react';
import { Label, Input, Flex, Block, Text, Title } from '@upsales/components';
import bemClass from '@upsales/components/Utils/bemClass';
import { useTranslation } from 'Components/Helpers/translate';
import { PrimaryButton, ThirdButton } from '@upsales/components/Buttons';
import './TicketFormSection.scss';

interface Props {
	internalName: string;
	handleNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	saving: boolean;
	reject: () => void;
}

const TicketFormSection = (props: Props) => {
	const { internalName, handleNameChange, saving, reject } = props;
	const { t } = useTranslation();
	const classes = new bemClass('TicketFormSection');

	const lang = {
		createTicketForm: t('ticket.createForm'),
		createTicketFormDescription: t('ticket.createTicketFormDescription'),
		nameYourTicketForm: t('form.nameYourForm'),
		formName: t('form.naming'),
		next: t('ticket.form.createButtonText'),
		abort: t('default.abort'),
		characterLimitReached: t('default.characterLimitReached')
	};

	return (
		<Flex direction="column" alignItems="center" justifyContent="center" className={classes.elem('container').b()}>
			<Flex direction="column" gap="u6" className={classes.elem('content').b()}>
				<Block>
					<Title size="lg" bold>
						{lang.createTicketForm}
					</Title>
					<Text color="grey-10" space="pts">
						{lang.createTicketFormDescription}
					</Text>
				</Block>
				<Block>
					<Label
						required
						value={internalName}
						maxLength={256}
						maxLengthReachedText={lang.characterLimitReached}
					>
						{lang.formName}
					</Label>
					<Input
						value={internalName}
						maxLength={256}
						onChange={handleNameChange}
						placeholder={lang.nameYourTicketForm}
					/>
				</Block>
				<PrimaryButton block disabled={!internalName} loading={saving} submit>
					{lang.next}
				</PrimaryButton>
				<ThirdButton color="grey" type="link" block onClick={reject} disabled={saving}>
					{lang.abort}
				</ThirdButton>
			</Flex>
		</Flex>
	);
};

export default TicketFormSection;
